/**
 * CallCompleteModal - Модальное окно для отметки звонка как выполненного
 */
import React, { useState } from 'react';
import {
  Modal,
  Textarea,
  Button,
  Group,
  Stack,
  Alert,
  Text,
} from '@mantine/core';
import { IconAlertCircle, IconCheck } from '@tabler/icons-react';

const CallCompleteModal = ({
  opened,
  onClose,
  onSubmit,
  call,
  loading = false,
}) => {
  const [result, setResult] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState(null);

  // Сброс формы при открытии
  React.useEffect(() => {
    if (opened) {
      setResult('');
      setComment('');
      setError(null);
    }
  }, [opened]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!result.trim()) {
      setError('Укажите результат звонка');
      return;
    }

    try {
      await onSubmit({
        result: result.trim(),
        comment: comment.trim() || null,
      });
    } catch (err) {
      setError(err.message || 'Ошибка при сохранении');
    }
  };

  const contactName = call?.contact
    ? [call.contact.last_name, call.contact.first_name].filter(Boolean).join(' ')
    : 'Неизвестный контакт';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Отметить звонок выполненным"
      size="md"
      radius="xl"
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          {error && (
            <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light">
              {error}
            </Alert>
          )}

          <Text size="sm" c="dimmed">
            Звонок с <strong>{contactName}</strong>
          </Text>

          <Textarea
            label="Результат звонка"
            placeholder="Договорились о встрече, отправили КП, нужен повторный звонок..."
            required
            autosize
            minRows={3}
            value={result}
            onChange={(e) => setResult(e.target.value)}
          />

          <Textarea
            label="Дополнительный комментарий"
            placeholder="Заметки для себя..."
            autosize
            minRows={2}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />

          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={onClose}>
              Отмена
            </Button>
            <Button
              type="submit"
              loading={loading}
              color="green"
              leftSection={<IconCheck size={16} />}
            >
              Выполнено
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default CallCompleteModal;
